import { Injectable } from '@angular/core';
import { QuestionService } from './question.service';

export class Answer{
  question_id:number = 0;
  question_label:string= '';
  question_type:string='';
  answer_id:number = 0;
  answer_text:string = '';
}
@Injectable({
  providedIn: 'root'
})
export class AnswerService {
  genderSelected:string="male";
  userAge:any;
  selectedCity:string='default'
  public currentAnswer:Answer = new Answer()
  constructor(public qService:QuestionService) { }

  submitAnswer(ans:any){
    this.qService.finalAnswers.push(ans);
    this.submitSingleAnswer(ans)
    this.qService.getNextQuestion();
  }

  submitSingleAnswer(ans:any){
      var data:any = {};
      if (typeof(ans["answer_text"]) == 'object') {
          if (Array.isArray(ans["answer_text"])) {
              data[ans["question_name"]] = [];
              for (let i = 0; i < ans["answer_text"].length; i++) {
                  data[ans["question_name"]].push(ans["answer_text"][i]["text"]);
              }
          }else{
            data[ans["question_name"]]=[ans["answer_text"]["text"]];
            let other_text = ans["answer_text"]["other_text"] || '';
            // If the answer is 'other', we need to add the other_text if it exists  
            if (other_text && other_text != '') {
              data[ans["question_name"]] = [other_text];
            }
            

          }
      }else{
          data[ans["question_name"]]=[ans["answer_text"]];
      }
      this.qService.submitSingleAnswer(data);
  }
  // resetAnswerBody(){
  //   return {
  //     question_label:'',
  //     answer_text:'',
  //   }
  // }
}
